export const Svg_095 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M23.625 50.02H28v-3.28h3.5c.778 0 1.398-.293 1.86-.876a3.09 3.09 0 0 0 .693-1.969V35.53c0-.79-.231-1.465-.693-2.024-.462-.56-1.082-.839-1.86-.839h-9.843v-5.031h12.396V23.26H28v-3.281h-4.375v3.281h-3.5c-.777 0-1.446.292-2.005.875-.559.583-.838 1.267-.838 2.05v8.296c0 .783.28 1.406.838 1.868.56.461 1.228.692 2.005.692h9.552v5.323H17.282v4.375h6.343v3.281Zm23.771-2.552 4.375-4.375h-8.75l4.375 4.375Zm-4.375-19.833h8.75l-4.375-4.375-4.375 4.375ZM10.21 58.333c-1.167 0-2.188-.438-3.063-1.313s-1.312-1.895-1.312-3.062V16.04c0-1.166.437-2.187 1.312-3.062s1.896-1.313 3.063-1.313h49.583c1.167 0 2.188.438 3.063 1.313s1.312 1.896 1.312 3.062v37.917c0 1.167-.437 2.187-1.312 3.062s-1.896 1.313-3.063 1.313H10.21Zm0-4.375h49.583V16.04H10.21v37.917Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.323}
        x2={39.015}
        y1={18.666}
        y2={58.504}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)